import {
  shorten,
  lengthen,
} from './queryParser';
import getObjectFromString from './getObjectFromString';
import getStringFromObject from './getStringFromObject';

export default {
  shorten,
  lengthen,
  getObjectFromString,
  getStringFromObject,
};



// WEBPACK FOOTER //
// ./app/utils/query/index.js